import { Message } from 'game/components/Message';
import { createStyles } from 'game/lib/createStyles';
import { colors, fontWeight, fonts } from 'game/styles/theme';
import { Component } from 'react';
import { DialogMessage } from './DialogMessage';
import { DialogMessageUI } from './DialogMessageUI';

const classes = createStyles({
  dialog: {
    userSelect: 'none',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    padding: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: fonts.nunito,
    fontWeight: fontWeight.bold,
    fontSize: '2rem',
  },
  dialogInner: {
    maxWidth: 800,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    position: 'relative',
    top: -40,
  },
  dialogBox: {
    position: 'absolute',
    top: '90%',
    width: '100%',
    background: colors.eggShell,
    border: `4px solid ${colors.darkBlue}`,
    borderRadius: 32,
    padding: '40px 30px',
    textAlign: 'center',
    '& em': {
      fontStyle: 'normal',
      fontWeight: 'inherit',
      color: colors.franklin,
    },
  },
  dialogSpeaker: {
    position: 'absolute',
    top: 0,
    left: 50,
    background: colors.franklin,
    color: colors.white,
    padding: '8px 24px',
    transform: 'translateY(-70%)',
    borderRadius: 100,
    border: `2px solid ${colors.black}`,
    boxShadow: `3px 4px 0 ${colors.black}`,
    fontWeight: fontWeight.extraBold,
    lineHeight: 1,
  },
});

interface DialogProps {
  messages: DialogMessage[],
  exit: () => void,
}

export class Dialog extends Component<DialogProps> {

  messageIndex = 0;

  advance = () => {
    this.messageIndex++;
    if (this.messageIndex >= this.props.messages.length) {
      this.props.exit();
    }
  };

  componentWillUnmount() {
    this.messageIndex = 0;
  }

  render() {
    const message = this.props.messages[this.messageIndex];
    if (!message) return null;

    return (
      <div className={classes.dialog}>
        <div className={classes.dialogInner}>
          {message.portrait}
          <div className={classes.dialogBox}>
            <div className={classes.dialogSpeaker}>
              <Message text="Franklin" />
            </div>
            <DialogMessageUI
              message={message}
              hasNext={this.messageIndex < this.props.messages.length - 1}
              advance={this.advance}
            />
          </div>
        </div>
      </div>
    );
  }
}
